import * as Container from './email-verification.container';
import * as Component from './email-verification.component';

export { Container, Component };

export default Container.default;
